function urlencodedParam(query, scope = '') {
    let key
    let value
    let out = ''
    // console.log("query:", Object.keys(query), "scope:", scope)
    Object.keys(query).forEach((name) => {
        key = scope ? `${scope}[${name}]` : name
        value = query[name]
        console.log("name:", name, "key:", key, "value:", value)
        if (value === undefined) return
        value === null && (value = '')
        if (typeof value === 'object' && !Array.isArray(value)) {
            out += urlencodedParam(value, key)
        } else {
            out += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        }
        // console.log("out:",out)
    })
    return scope ? out : out.substr(1)
}

const baseUrl = "https://www.hololux.cn";

export default async function networkAction(url, method, data = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            method = method.toUpperCase() || 'POST';
            // let contentType = 'application/x-www-form-urlencoded';
            const header = {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
            const input = urlencodedParam(data)
            
            url = baseUrl + url
            const res = await fetch(url, {
                method: method,
                headers: header,
                body: method === "POST" ? input : null
            })
            if (res) {
                const resData = await res.json()
                resolve(resData)
            } else {
                resolve(null)
            }
        } catch(error) {
            reject(error)
        }
    })
}
